module.exports = __webpack_public_path__ + "img/pendTrial2-icon.d39301c5.png";